@use "colors";

:export {
    white: #{colors.$white};
    grey: #{colors.$grey};
    darkGrey: #{colors.$dark-grey};
    lightGrey: #{colors.$light-grey};
    black: #{colors.$black};
    red: #{colors.$red};
    deepRed: #{colors.$deep-red};
    lightRed: #{colors.$light-red};
    orange: #{colors.$orange};
    paleOrange: #{colors.$pale-orange};
    amber: #{colors.$amber};
    yellow: #{colors.$yellow};
    green: #{colors.$green};
    turquoise: #{colors.$turquoise};
    blue: #{colors.$blue};
    violet: #{colors.$violet};
    deepViolet: #{colors.$deep-violet};
    lightViolet: #{colors.$light-violet};
    pink: #{colors.$pink};
}